import { defineComponent as _defineComponent } from 'vue'
import TableauPopup from "../../ui-components/TableauPopup.vue";
import TableauTextBox from "../../ui-components/TableauTextBox.vue";
import TableauRichTextBox from "../../ui-components/TableauRichTextBox.vue";
import { computed, reactive, ref } from "vue";
import {
  EmailButtonInfoDTO,
  EmailInputDTO,
  ErrorTypes,
} from "../common/api/autogenerated";
import { container } from "tsyringe";
import { ApiModule } from "../common/api/api.module";
import { ContactOwnerModule } from "./contact-owner.module";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactOwnerPopup',
  props: {
    info: { type: Object, required: true },
    screenshot: { type: null, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const status = ref<"idle" | "loading" | "success" | "error">("idle");
const statusMessage = ref("");
const fromEmail = ref(props.info.fromEmail);
const toEmail = ref(props.info.toEmail);
const subject = ref("");
const message = ref("");
const canSend = computed(
  () =>
    !!fromEmail.value && !!toEmail.value && !!subject.value && !!message.value
);
if (!props.screenshot) {
  status.value = "error";
  statusMessage.value =
    "Failed to take a screenshot, email will be sent without one. Re-open this window to try to take a screenshot again.";
} else {
  status.value = "idle";
  statusMessage.value = "Screenshot of the dashboard will also be sent";
}
const popup = ref<InstanceType<typeof TableauPopup> | null>(null);
async function send() {
  status.value = "loading";
  statusMessage.value = "Sending email...";
  const apiModule = container.resolve(ApiModule);
  const contactOwnerModule = container.resolve(ContactOwnerModule);
  const api = await apiModule.apiRequest((c) =>
    c.apiEmailIntegrationButtonSendEmail(
      new EmailInputDTO({
        body: message.value,
        subject: subject.value,
        token: props.info.token,
        overrideSender: fromEmail.value,
        overrideRecipient: toEmail.value,
        dashboardImage: props.screenshot,
      })
    )
  );
  if (api.success) {
    status.value = "success";
    statusMessage.value = "Email sent";
    setTimeout(() => popup.value?.close(), 2000);
  } else {
    status.value = "error";
    statusMessage.value = "Failed to send email";
    switch (api.error!.error) {
      case ErrorTypes.EmailInfoTokenNotFound:
        statusMessage.value +=
          " due to session timeout. Please refresh the page and try again.";
        break;
      default:
        statusMessage.value +=
          " due to an unspecified error. Please report this to the administrator";
        break;
    }
    contactOwnerModule.log.e("Failed to send email", statusMessage.value);
  }
}

const __returned__ = { props, status, statusMessage, fromEmail, toEmail, subject, message, canSend, popup, send, TableauPopup, TableauTextBox, TableauRichTextBox }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})